/* eslint-disable @typescript-eslint/strict-boolean-expressions */
import { QueryCache } from "@tanstack/react-query";
// import toast from "react-hot-toast";
// import * as auth from 'auth-provider'

const apiURL = "https://app.intradable.com";
// const apiURL = "https://ipx.intradable.com";

const queryCache = new QueryCache({
  onError: (error) => {
    console.log(error);
  },
  onSuccess: (data) => {
    console.log(data);
  },
});

async function client(
  endpoint: string,
  {
    data,
    headers: customHeaders,
    ...customConfig
  }: Partial<RequestInit> & { data?: unknown } = {}
) {
  const token = localStorage.getItem("token");
  const config: RequestInit = {
    method: data ? "POST" : "GET",
    body: data instanceof FormData ? data : JSON.stringify(data),
    headers: {
      Authorization: token ? `Bearer ${token}` : "",
      ...(!data || data instanceof FormData
        ? {}
        : { "Content-Type": "application/json" }),
      ...customHeaders,
    },
    ...customConfig,
  };

  return await window
    .fetch(`${apiURL}/${endpoint}`, config)
    .then(async (response) => {
      const data = await response.json();

      if (response.status === 401 && endpoint !== "auth/login") {
        queryCache.clear();
        // await auth.logout()
        // refresh the page for them
        // toast.error(data?.message);
        // eslint-disable-next-line prefer-promise-reject-errors
        return await Promise.reject({ message: "Please re-authenticate." });
      }
      if (response.ok) {
        return data;
      } else {
        // toast.error(data?.message);
        return await Promise.reject(data);
      }
    });
}

export { client };
